import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";

import { getAppType } from "../constant/appType";
import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { SessionInvalidatedError } from "../Utils/axiosSessionInterceptor";

type RefreshAuthRequest = {
  token: string;
  userId?: string;
};

export interface RefreshAuthResponse {
  accessToken: string;
  expiresIn: string;
}

const refreshAuth = async ({ token, userId }: RefreshAuthRequest): Promise<RefreshAuthResponse> => {
  try {
    const appType = getAppType();

    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/auth/refresh`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          ...(appType && { "X-App-Type": appType }),
          ...(userId && { "X-Active-User": userId }),
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    // If the interceptor already converted this to a SessionInvalidatedError,
    // re-throw as-is so callers (useJwtExpiry, React Query) can identify it
    if (e instanceof SessionInvalidatedError) throw e;

    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default refreshAuth;
